import { createClient } from '@supabase/supabase-js';

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://ysgyxvkvnxbxtwdnddlv.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlzZ3l4dmt2bnhieHR3ZG5kZGx2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMTM2NzQsImV4cCI6MjA5NjU4OTY3NH0.Tw4sEiubkL2jW9DBb9q7n5LjUAm32YB0dIS4QQMh88M';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});